import styled from 'styled-components';

export const Spread = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
